module.exports = __webpack_public_path__ + "assets/img/inetum.73569176.png";